import { Pipe, PipeTransform } from '@angular/core';

function getProductTypeFilterFunction(productTypeCheckboxes) {
  if (!productTypeCheckboxes?.length) {
    return () => true;
  }
  const checkedIds = new Set(productTypeCheckboxes.filter(pt => pt.checked).map(pt => pt.id)); // Use Set for faster lookups
  return item => checkedIds.has(item.location?.policy?.productType?.id);
}

@Pipe({
  name: 'searchPipe',
  pure: false,
})
export class SearchPipe implements PipeTransform {
  transform(items: any[], args?: any): any {
    if (!args || !items) {
      return items;
    }

    if (!args.searchTerm || typeof args.searchTerm !== 'string') {
      args.searchTerm = '';
    }
    if (!args.productTypes?.length) {
      args.productTypes = [];
    }

    const filterByProductType = getProductTypeFilterFunction(args.productTypes);
    items = items.filter(filterByProductType);

    if (Array.isArray(args.filteredAssignees) && args.filteredAssignees.length > 0) {
      const assigneeIds = new Set(args.filteredAssignees);

      items = items.filter(item => {
        if (assigneeIds.has(0)) {
          return item.assigneeId == null || assigneeIds.has(item.assigneeId);
        }
        return assigneeIds.has(item.assigneeId);
      });
    }

    const searchTerm = args.searchTerm.toLowerCase().replace(/\s+/g, '').replace('#', '');
    if (!searchTerm) {
      return items;
    }

    items = items.filter(item => {
      return (
        (searchTerm &&
          ((item.customerName && item.customerName.toLowerCase().replace(/\s+/g, '').indexOf(searchTerm) !== -1) ||
            (item.policyNumber && item.policyNumber.toLowerCase().replace(/\s+/g, '').indexOf(searchTerm) !== -1) ||
            (item.inspector && item.inspector.name.toLowerCase().replace(/\s+/g, '').indexOf(searchTerm) !== -1) ||
            (item.locationId && item.locationId.toLowerCase().replace(/\s+/g, '').indexOf(searchTerm) !== -1))) ||
        (item.vendor && item.vendor.name.toLowerCase().replace(/\s+/g, '').indexOf(searchTerm) !== -1)
      );
    });

    const searchField = args.searchField;
    if (searchField) {
      return items
        .filter(item => {
          if (searchField === 'inspectorName' && item.inspector) {
            return item.inspector.name.toLowerCase().replace(/\s+/g, '').indexOf(searchTerm) !== -1;
          } else if (searchField === 'customerName') {
            return item.customerName.toLowerCase().replace(/\s+/g, '').indexOf(searchTerm) !== -1;
          } else if (searchField === 'policyNumber') {
            return item.policyNumber.toLowerCase().replace(/\s+/g, '').indexOf(searchTerm) !== -1;
          } else if (searchField === 'vendorName') {
            return item.vendor.name.toLowerCase().replace(/\s+/g, '').indexOf(searchTerm) !== -1;
          }
        })
        .filter(filterByProductType);
    } else {
      return items;
    }
  }
}
